import { toLocalDate } from "./dateOnly";

export const normalizeDate = (date: Date | string | null) => {
  return toLocalDate(date);
};
